import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkSkuCategoryStatsSection.module.css';

export function DevlinkSkuCategoryStatsSection({
  as: _Component = _Builtin.Section,
  skuCategoryCompletionCount = '100000',
  skuCategoryName = '<Category Name>',
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'ht-sku-category-stats-section')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-sku-category-stats-value')} tag="div" comma="on">
            {skuCategoryCompletionCount}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'tiny')} tag="div" />
          <_Builtin.Block className={_utils.cx(_styles, 'div-block-73')} tag="div">
            <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>{skuCategoryName}</_Builtin.Paragraph>
            <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>{'Services Completed'}</_Builtin.Paragraph>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
